import React from "react";

import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";

import {
  FilterBodyWrapper,
  FilterElementWrapper,
  FilterTitleWrapper,
  SelectionAction,
  SelectionActions,
  SelectionDivider,
} from "./styles";
import { FilterElementProps } from "./types";

/**
 * Componente FilterElement
 *
 * Representa um elemento de filtro com título, ícone e corpo para os conteúdos dinâmicos.
 *
 * @param {string} title - Título do filtro.
 * @param {string} iconName - Nome do ícone associado ao filtro.
 * @param {React.ReactNode} children - Elementos filhos a serem exibidos no corpo do filtro.
 */
export const FilterElement: React.FC<FilterElementProps> = ({
  title,
  iconName,
  children,
  hasBorder = true,
  onToggleAll,
}) => {
  const library = iconName.startsWith("Lu")
    ? "lu"
    : iconName.startsWith("Md")
      ? "md"
      : "fa";

  return (
    <FilterElementWrapper hasBorder={hasBorder}>
      <FilterTitleWrapper>
        <Icon library={library} color="black" name={iconName} />
        <Typography color="black" weight="semiBold" uppercase>
          {title}
        </Typography>
      </FilterTitleWrapper>
      {onToggleAll && (
        <SelectionActions aria-label={`Ações do filtro ${title}`}>
          <SelectionAction type="button" onClick={() => onToggleAll(true)}>
            Marcar todos
          </SelectionAction>
          <SelectionDivider aria-hidden="true" />
          <SelectionAction type="button" onClick={() => onToggleAll(false)}>
            Desmarcar todos
          </SelectionAction>
        </SelectionActions>
      )}
      <FilterBodyWrapper>{children}</FilterBodyWrapper>
    </FilterElementWrapper>
  );
};
